export default {"src":"/_next/static/media/commission-filled.4601c501.svg","height":30,"width":30};